const listOfMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

export const getDateAndTime = (dateFromDB) => {
    const [datePart, timePart] = dateFromDB.split(" ");
    const date = new Date(`${datePart}T${timePart}`);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return `${formattedDate} | ${formattedTime}`;
};

export const getLastDateOfMonth = (year, month) => {
    // Create a Date object for the next month's first day
    const nextMonthFirstDay = new Date(year, month + 1, 1);
    // Subtract one day from the next month's first day to get the last day of the current month
    const lastDateOfMonth = new Date(nextMonthFirstDay.getTime() - 1);
    return lastDateOfMonth.getDate();
};

export const getStartAndEndTimeOfMonth = (year, month) => {
    const startTimeUTC = new Date(Date.UTC(year, month, 1, 0, 0, 0));
    const lastDate = getLastDateOfMonth(year, month);
    const endTimeUTC = new Date(Date.UTC(year, month, lastDate, 23, 59, 59, 999));
    const monthObj = {
        label: `${listOfMonths[month]} ${String(year)}`,
        startDate: startTimeUTC.toISOString(),
        endDate: endTimeUTC.toISOString()
    };
    return monthObj;
}

export const getPreviousMonths = (duration = 11) => {
    const today = new Date();
    const months = [];
    for (let i = duration; i >= 0; i--) {
        const newDate = new Date(today.getFullYear(), today.getMonth() - i);
        const month = newDate.getMonth();
        const year = newDate.getFullYear();
        const monthObj = getStartAndEndTimeOfMonth(year, month);
        months.unshift(monthObj);
    }
    return months;
};
